import { Disclosure } from '@headlessui/react'
import { IconChevronDown } from '@tabler/icons-react'
import { classNames } from 'util/classNames'

export const InputHeading = ({
  icon,
  title,
  description,
  onClick,
  expandable = false,
  expandedNode,
}: {
  icon: React.ReactNode
  title: string
  description?: string
  onClick?: () => void
  expandable?: boolean
  expandedNode?: React.ReactNode
}) => {
  return (
    <div className="mb-1 flex flex-col items-start gap-2 text-sm">
      <div className="flex flex-col items-start gap-2">
        <div className="flex items-start gap-2 text-sm font-medium">
          {icon}
          <p>{title}</p>
        </div>

        {expandable ? (
          <Disclosure>
            {({ open }) => (
              <div>
                <Disclosure.Button className="flex items-center gap-2 text-xs text-gray-500">
                  <span
                    className={classNames(
                      'cursor-pointer transition-all duration-300 hover:text-toasty-blue-500 hover:underline hover:underline-offset-1',
                      onClick ? 'cursor-pointer' : ''
                    )}
                    onClick={onClick}
                  >
                    {description}
                  </span>
                  <IconChevronDown
                    className={classNames(
                      'h-5 w-5 transform transition-transform duration-300',
                      open ? 'rotate-180' : 'rotate-0'
                    )}
                  />
                </Disclosure.Button>

                <Disclosure.Panel
                  static
                  className="transition-max-height overflow-hidden duration-300 ease-in-out"
                  style={{ maxHeight: open ? '1000px' : '0px' }}
                >
                  <div>{expandedNode}</div>
                </Disclosure.Panel>
              </div>
            )}
          </Disclosure>
        ) : (
          description && (
            <p
              className={classNames(
                'cursor-pointer text-xs text-gray-500',
                onClick
                  ? 'cursor-pointer transition-all duration-300 hover:font-semibold hover:text-toasty-blue-500'
                  : ''
              )}
              onClick={onClick}
            >
              {description}
            </p>
          )
        )}
      </div>
    </div>
  )
}
